import styled from '@emotion/styled/macro';
import themeGet from '@styled-system/theme-get';
import { Box } from './Box';

export const Divider = styled(Box)(props => ({
  backgroundColor: themeGet('colors.divider')(props)
}));
